var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-gallery",style:({ backgroundImage: `url(${_vm.images[0]})` })},[_c('am-icon',{staticClass:"am-gallery__fullscreen",attrs:{"dark":true,"name":"fullscreen","size":"sm"},nativeOn:{"click":function($event){return _vm.$emit('open', _vm.images)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }